import React, {useState} from "react";
import { useField, useFormikContext } from 'formik';
import {FieldError} from "../Error/FieldError.jsx";
import {DateRangePicker} from "@progress/kendo-react-dateinputs";

export const DateRangePickerInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [shouldShow, setShouldShow] = useState(false);
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;

    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
            if(newValue?.start && newValue?.end) setShouldShow(false);
        }
    };

    const handleShow = (bool) => {
        setShouldShow(bool);
    }

    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <DateRangePicker
                inputAttributes={{style: {width: "100%"}}}
                id={otherProps.id || otherProps.name}
                value={field.value || { start: null, end: null }}
                {...otherProps}
                show={shouldShow}
                onChange={handleChange}
                onFocus={() => handleShow(true)}
                onBlur={() => handleShow(false)}
                clearButton={true}
                disabled={isDisabled}
            />
            <FieldError name={otherProps.name}/>
        </>
    );
};